<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-sm-6">
            <h1 class="title-default">Super Acesso</h1>
        </div>
        <div class="col-sm-6">
            <a type="button" mat-button class="btn-primary btn-add-right" routerLink="/suporte/super-acesso/cadastrar" *appTemPermissao="_PermissaoEnum.Suporte_SuperAcesso_Incluir">
                <mat-icon>add</mat-icon>
                Novo Acesso
            </a>
        </div>
    </div> 
    <form class="form" [formGroup]="model" (ngSubmit)="clickPesquisar()" class="search-area">
        <div class="row">
            <div class="col-md-6">
                <app-select-pesquisavel
                    label="Selecione uma Empresa"
                    [control]="listaIdEmpresaControl"
                    [apiUrl]="_urlListEmpresa"
                    [idField]="'idEmpresa'"
                    [nameField]="'nomeEmpresa'"
                    [isOptional]="true"
                    [preloadedOptions]="preloadedEmpresa">
                </app-select-pesquisavel>
            </div>  
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Selecione o(a) usuário(a)</mat-label> 
                    <mat-select  formControlName="listaIdUsuario">
                        @if(_usuarioLookupResponse){
                            @for (usuario of _usuarioLookupResponse.listaUsuario; track usuario) {
                                <mat-option [value]="usuario.idUsuario">{{usuario.nomeUsuario}}</mat-option>
                            }
                        } 
                    </mat-select>  
                    @if (model.get('listaIdUsuario')?.invalid) {
                        <mat-error>Selecione uma empresa</mat-error>
                    }           
                </mat-form-field>
            </div>
            <div class="col-md-2" style="min-width: 210px">
                <mat-form-field appearance="outline">
                    <mat-label>Informe uma data</mat-label>   
                    <input matInput [matDatepicker]="picker" formControlName="datetimeInclusao">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="col-md-6 d-flex"  style="gap: 10px;">
                <button type="submit" mat-button class="btn-primary" style="width: 140px;">
                    Pesquisar
                </button>
                <button type="button" mat-button class="btn-secundary" style="width: 140px;" (click)="limpaCampos()">
                    Limpar
                </button>
            </div>
        </div>
    </form>
    
    @if(this._listaSuperAcessoResponse && this._listaSuperAcessoResponse.listaSuperAcesso.length > 0){
        <table mat-table [dataSource]="_dataSource.data">
            <ng-container matColumnDef="idEmpresa">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Empresa </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeEmpresa}} </td>
            </ng-container>

            <ng-container matColumnDef="idUsuario">
                <th mat-header-cell *matHeaderCellDef> Nome do usuário </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeUsuario}} </td>
            </ng-container>

            <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
            </ng-container>

            <ng-container matColumnDef="data">
                <th mat-header-cell *matHeaderCellDef> Data </th>
                <td mat-cell *matCellDef="let element"> {{element.datahoraInclusao | date: 'dd/MM/yyyy HH:mm:ss'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div class="col-12 text-center ver-mais-pesquisa">
            <button type="button" mat-button class="btn-primary" [disabled]="_ultimaPagina" (click)="proximaPagina()">
                @if (_isLoading === true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                }
                @else{
                    <span class="material-symbols-outlined">keyboard_arrow_down</span>
                    Ver mais
                }
            </button>
        </div>
    }@else if(_isLoading === true){
        <table>
            @for (item of [1,2,3]; track item) {
                <tr>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'110'" [marginTop]="'30'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'320'" [marginTop]="'30'"  [marginLeft]="'50'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'100'"></app-loading-box>
                    </td>
                    <td>
                        <app-loading-box [height]="'23'" [width]="'40'" [marginTop]="'30'"  [marginLeft]="'20'"></app-loading-box>
                    </td>
                </tr>
            }
            
        </table>
    }
    @else if(this._listaSuperAcessoResponse.listaSuperAcesso.length === 0){
        <app-empty-list [title]="'Não foi encontrado nenhum relatório com o filtro informado'"></app-empty-list>
    }

</div>
